import { EventEmitter } from '@angular/core';
var ModuleValue = (function () {
    function ModuleValue() {
    }
    return ModuleValue;
}());
export { ModuleValue };
;
var SchemaModule = (function () {
    function SchemaModule() {
        this.updater = new EventEmitter();
        this.rebuild = new EventEmitter();
        this.validators = {};
    }
    SchemaModule.prototype.ngOnInit = function () {
        this.setupValidators();
    };
    /**
     * Called when parent form has finished loading. Used to set up custom value listeners.
     * @param form Parent form component
     */
    SchemaModule.prototype.hook = function (form) {
        var _this = this;
        this.form = form;
        if (!this.schemaUsesOrderByProcedure())
            return;
        var mpProp = this.form.rootProperty.searchProperty('/main_procedure');
        if (!mpProp)
            return;
        mpProp.valueChanges.subscribe(function (value) {
            if (!value)
                return;
            _this.reorderForProcedure(value);
        });
    };
    SchemaModule.prototype.loadSchema = function (schema) {
        // Create a copy to prevent breaking the original
        this.schema = JSON.parse(JSON.stringify(schema));
        this.applyOrderByProcedureToOrder(this.resolveInitialProcedure());
    };
    /**
     * Initial pass, before the SchemaPreprocessor runs: wherever a node has
     * `orderByProcedure`, reorder `node.order` using the procedure's list. Fields
     * not in that list are appended, preserving the flat order as fallback (so
     * the preprocessor's `checkFieldsUsage` still sees every property).
     */
    SchemaModule.prototype.applyOrderByProcedureToOrder = function (procedure, node) {
        if (node === void 0) { node = this.schema; }
        if (!node || typeof node !== 'object')
            return;
        var obp = node.orderByProcedure;
        if (obp && Array.isArray(node.order)) {
            var base = this.pickProcedureList(obp, procedure);
            if (base)
                node.order = this.mergeOrder(base, node.order);
        }
        if (node.properties) {
            for (var _i = 0, _a = Object.keys(node.properties); _i < _a.length; _i++) {
                var k = _a[_i];
                this.applyOrderByProcedureToOrder(procedure, node.properties[k]);
            }
        }
        if (node.items && !Array.isArray(node.items)) {
            this.applyOrderByProcedureToOrder(procedure, node.items);
        }
    };
    /**
     * Runtime pass, after the preprocessor consumed `order`: mutate
     * `fieldsets[0].fields` in place for each node with `orderByProcedure`.
     * Template uses `*ngFor` over fieldsets.fields with `getProperty(fieldId)`
     * so a new array reference triggers re-iteration while reusing existing
     * FormProperty instances — form state is preserved.
     */
    SchemaModule.prototype.applyOrderByProcedureToFieldsets = function (procedure, node) {
        if (node === void 0) { node = this.schema; }
        if (!node || typeof node !== 'object')
            return;
        var obp = node.orderByProcedure;
        if (obp && Array.isArray(node.fieldsets) && node.fieldsets[0] && Array.isArray(node.fieldsets[0].fields)) {
            var base = this.pickProcedureList(obp, procedure);
            if (base) {
                // Merge against the *current* fieldset list — which preserves any Vue
                // shell pruning (e.g. `proms` removed at AppCaseSidebar.vue:350) and
                // covers procedure-specific fields the pick list may omit.
                node.fieldsets[0].fields = this.mergeOrder(base, node.fieldsets[0].fields);
            }
        }
        if (node.properties) {
            for (var _i = 0, _a = Object.keys(node.properties); _i < _a.length; _i++) {
                var k = _a[_i];
                this.applyOrderByProcedureToFieldsets(procedure, node.properties[k]);
            }
        }
        if (node.items && !Array.isArray(node.items)) {
            this.applyOrderByProcedureToFieldsets(procedure, node.items);
        }
    };
    SchemaModule.prototype.pickProcedureList = function (obp, procedure) {
        var base = (procedure && obp[procedure]) || obp._default || Object.values(obp)[0];
        return Array.isArray(base) ? base : null;
    };
    /**
     * Reorder `existing` to match `base` where the two overlap, then append any
     * remaining `existing` entries. Drops names in `base` that aren't in
     * `existing` — they'd be invented fields the form doesn't know about.
     */
    SchemaModule.prototype.mergeOrder = function (base, existing) {
        var existingSet = new Set(existing);
        var seen = new Set();
        var result = [];
        for (var _i = 0, base_1 = base; _i < base_1.length; _i++) {
            var name_1 = base_1[_i];
            if (existingSet.has(name_1) && !seen.has(name_1)) {
                result.push(name_1);
                seen.add(name_1);
            }
        }
        for (var _a = 0, existing_1 = existing; _a < existing_1.length; _a++) {
            var name_2 = existing_1[_a];
            if (!seen.has(name_2)) {
                result.push(name_2);
                seen.add(name_2);
            }
        }
        return result;
    };
    SchemaModule.prototype.resolveInitialProcedure = function () {
        var mp = this.schema.properties && this.schema.properties.main_procedure;
        return mp && typeof mp.default === 'string' ? mp.default : undefined;
    };
    SchemaModule.prototype.schemaUsesOrderByProcedure = function (node) {
        if (node === void 0) { node = this.schema; }
        if (!node || typeof node !== 'object')
            return false;
        if (node.orderByProcedure)
            return true;
        if (node.properties) {
            for (var _i = 0, _a = Object.keys(node.properties); _i < _a.length; _i++) {
                var k = _a[_i];
                if (this.schemaUsesOrderByProcedure(node.properties[k]))
                    return true;
            }
        }
        if (node.items && !Array.isArray(node.items)) {
            return this.schemaUsesOrderByProcedure(node.items);
        }
        return false;
    };
    SchemaModule.prototype.reorderForProcedure = function (procedure) {
        this.applyOrderByProcedureToFieldsets(procedure);
        this.rebuild.emit();
    };
    SchemaModule.prototype.loadLocations = function (locations) {
        var locationSchema = this.schema.properties['location'];
        locationSchema.enum = Object.keys(locations).map(Number);
        locationSchema.options.enum_titles = Object.values(locations);
        this.setupValidators();
    };
    SchemaModule.prototype.getProperty = function (propertyPath) {
        return this.form.rootProperty.searchProperty("/" + propertyPath);
    };
    SchemaModule.prototype.listenValue = function (propertyPaths, listener) {
        var _this = this;
        var propertyPathsArray = [].concat(propertyPaths);
        propertyPathsArray.forEach(function (propertyPath, propertyIndex) {
            _this.getProperty(propertyPath).valueChanges.subscribe(function (value) {
                var values = propertyPathsArray.map(function (p, i) { return i === propertyIndex ? value : _this.getValue(p, true); });
                listener.apply(void 0, values);
            });
        });
    };
    SchemaModule.prototype.getValue = function (propertyPath, checkVisibility) {
        if (checkVisibility === void 0) { checkVisibility = false; }
        var property = this.getProperty(propertyPath);
        if (checkVisibility && !property.visible)
            return undefined;
        return property.value;
    };
    SchemaModule.prototype.updateValue = function (propertyPath, newValue) {
        if (newValue !== this.getValue(propertyPath)) {
            this.getProperty(propertyPath).setValue(newValue, false);
        }
    };
    SchemaModule.prototype.listenVisibility = function (propertyPath, listener) {
        this.getProperty(propertyPath).visibilityChanges.subscribe(listener);
    };
    /**
     * Difference between two date strings expressed in months. Returns `null` if
     * either date is missing. `divisor` is the average days-per-month used to
     * convert the day difference (e.g. 30.5 for follow-up duration).
     */
    SchemaModule.prototype.diffInMonths = function (a, b, divisor) {
        if (!a || !b)
            return null;
        var diffMs = new Date(a).getTime() - new Date(b).getTime();
        var diffDays = diffMs / (1000 * 60 * 60 * 24);
        return Math.round((diffDays / divisor) * 10) / 10;
    };
    /**
     * Helper function to compare two values using the provided operator.
     * @param value1 First value
     * @param value2 Second value
     * @param operator Comparison operator
     */
    SchemaModule.prototype.relation = function (value1, value2, operator) {
        var operatorFunctions = {
            '==': function (a, b) { return a == b; },
            '!=': function (a, b) { return a != b; },
            '>': function (a, b) { return a > b; },
            '>=': function (a, b) { return a >= b; },
            '<': function (a, b) { return a < b; },
            '<=': function (a, b) { return a <= b; },
        };
        return operatorFunctions[operator](value1, value2);
    };
    /**
     * Generate error messages for value comparison validators
     * @param property1 First Property
     * @param property2 Second property
     * @param operator Comparison operator
     * @param valueType Type of value being compared
     */
    SchemaModule.prototype.relationMessage = function (property1, property2, operator, valueType) {
        if (valueType === void 0) { valueType = 'number'; }
        var relationalOperatorMessages = {
            'number': {
                '==': '%0 must be equal to %1.',
                '!=': '%0 must not be equal to %1.',
                '>': '%0 must be greater than %1.',
                '>=': '%0 must be greater than or equal to %1.',
                '<': '%0 must be less than %1.',
                '<=': '%0 must be less than or equal to %1.',
            },
            'date': {
                '==': '%0 must be equal to %1.',
                '!=': '%0 must not be equal to %1.',
                '>': '%0 must be later than %1.',
                '>=': '%0 must be later than or equal to %1.',
                '<': '%0 must be earlier than %1.',
                '<=': '%0 must be earlier than or equal to %1.',
            },
        };
        return this.generateMessage(relationalOperatorMessages[valueType][operator], property1, property2);
    };
    /**
     * Create a message by injecting property titles into placeholders.
     *
     * @param message Message with placeholders. A placeholder is a percent signs followed by a number.
     * This number is the index of the property parameter starting at zero. For example: `%0` or `%13`
     * @param properties The name of each property to be injected into the message.
     * @returns string The compiled message
     * @example
     * generateMessage( 'The %0 field requires %1 to be selected', 'first_name', 'generate_user' )
     * // 'The First Name field requires Generate User to be selected'
     */
    SchemaModule.prototype.generateMessage = function (message) {
        var _this = this;
        var properties = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            properties[_i - 1] = arguments[_i];
        }
        return message.replace(/%\d+/g, function (index) {
            return _this.getProperty(properties[parseInt(index.substr(1))]).schema.title;
        });
    };
    SchemaModule.prototype.relationalOperatorConverse = function (operator) {
        var converseOperators = {
            '==': '==',
            '!=': '!=',
            '>': '<',
            '>=': '<=',
            '<': '>',
            '<=': '>=',
        };
        return converseOperators[operator];
    };
    /**
     * Generate a validator for array-type properties that are required to have at least one value.
     * @param property Field property to validate
     */
    SchemaModule.prototype.validatorRequiredArray = function (property) {
        this.addValidator(property, function (value, formProperty, form) {
            if (!formProperty.visible)
                return [];
            if (value.length === 0) {
                return [{
                        code: 'PROPERTY_VALUE_REQUIRED',
                        path: "#/" + property,
                        message: "Missing required property: " + property,
                        params: [property],
                    }];
            }
            return [];
        });
    };
    /**
     * Add validators to compare the values of two properties
     * @param property1 First property
     * @param property2 Second property
     * @param operator Comparison operator
     * @param valueTranslator Function to convert values
     * @param message Override error message
     * @param valueType Type of value being compared. Used to generate message.
     * @param setupTwin Attach validator to second property. Default `true`
     */
    SchemaModule.prototype.validatorValueComparison = function (property1, property2, operator, valueTranslator, message, valueType, setupTwin) {
        var _this = this;
        if (setupTwin === void 0) { setupTwin = true; }
        var twinSubscribed = false;
        this.addValidator(property1, function (value1, formProperty, form) {
            var value2 = _this.getValue(property2);
            var translatedValue1 = valueTranslator ? valueTranslator(value1) : value1;
            var translatedValue2 = valueTranslator ? valueTranslator(value2) : value2;
            var code1 = "validatorValueComparison|" + property1 + "|" + property2;
            var code2 = "validatorValueComparison|" + property2 + "|" + property1;
            var property1Obj = form.getProperty(property1);
            var property2Obj = form.getProperty(property2);
            var propertyMissing = function (propertyObj, value) {
                return propertyObj.schemaValidatorFactory.isPropertyMissing(value, propertyObj.schema);
            };
            var clearTwinErrors = function () {
                property2Obj.setErrors(property2Obj.filterErrors(function (error) { return error.code !== code2; }));
            };
            if (!twinSubscribed) {
                twinSubscribed = true;
                property1Obj.valueChanges.subscribe(function (value) {
                    if (propertyMissing(property1Obj, value)) {
                        clearTwinErrors();
                    }
                });
            }
            // Don't validate if...
            if (
            // ... either of the fields are empty
            (propertyMissing(property1Obj, value1) || propertyMissing(property2Obj, value2)) ||
                // ... either of the fields are hidden
                (!property1Obj.visible || !property2Obj.visible)) {
                clearTwinErrors();
                return [];
            }
            if (!_this.relation(translatedValue1, translatedValue2, operator)) {
                // Also add the error to the twin property
                property2Obj.extendErrors([{
                        code: code2,
                        path: "#/" + property2,
                        message: message || _this.relationMessage(property2, property1, _this.relationalOperatorConverse(operator), valueType),
                    }]);
                return [{
                        code: code1,
                        path: "#/" + property1,
                        message: message || _this.relationMessage(property1, property2, operator, valueType),
                    }];
            }
            else {
                clearTwinErrors();
                return [];
            }
        });
        // Don't run this if already in the 'twin' validator
        if (setupTwin) {
            this.validatorValueComparison(property2, property1, this.relationalOperatorConverse(operator), valueTranslator, message, valueType, false);
        }
    };
    /**
     * Add validators to compare two date properties
     * @param dateProperty1 First date property
     * @param dateProperty2 Second date property
     * @param operator Comparison operator
     * @param message Override error message
     */
    SchemaModule.prototype.validatorDateComparison = function (dateProperty1, dateProperty2, operator, message) {
        this.validatorValueComparison(dateProperty1, dateProperty2, operator, function (v) { return new Date(v); }, null, 'date');
    };
    /**
     * Add validators to compare two date properties
     * @param dateProperty1 First date property
     * @param dateValue instance of Date class
     * @param operator Comparison operator
     * @param valueTranslator
     * @param message Override error message
     */
    SchemaModule.prototype.validatorDate = function (dateProperty1, dateValue, operator, valueTranslator, message) {
        // let valueTranslator = v => new Date( v as any );
        var _this = this;
        this.addValidator(dateProperty1, function (value1, formProperty, form) {
            var translatedValue1 = valueTranslator ? valueTranslator(value1) : value1;
            var code1 = "validatorValueComparison|" + dateProperty1 + "|";
            var property1Obj = form.getProperty(dateProperty1);
            var propertyMissing = function (propertyObj, value) {
                return propertyObj.schemaValidatorFactory.isPropertyMissing(value, propertyObj.schema);
            };
            // Don't validate if...
            if (
            // ... either of the fields are empty
            (propertyMissing(property1Obj, value1)) ||
                // ... either of the fields are hidden
                (!property1Obj.visible)) {
                return [];
            }
            if (!_this.relation(translatedValue1, dateValue, operator)) {
                var operatorMessages = {
                    '==': '%0 must be equal to %1.',
                    '!=': '%0 must not be equal to %1.',
                    '>': '%0 must be later than %1.',
                    '>=': '%0 must be later than or equal to %1.',
                    '<': '%0 must be earlier than %1.',
                    '<=': '%0 must be earlier than or equal to %1.',
                };
                if (!message) {
                    message = operatorMessages[operator]
                        .replace('%0', (_this.getProperty(dateProperty1).schema).title)
                        .replace('%1', dateValue.toISOString().split('T')[0]);
                }
                // Also add the error to the twin property
                return [{
                        code: code1,
                        path: "#/" + dateProperty1,
                        message: message,
                    }];
            }
            else {
                return [];
            }
        });
    };
    /**
     * Attach a validator function to a property
     * @param property Property name
     * @param validator Validator function
     */
    SchemaModule.prototype.addValidator = function (property, validator) {
        if (typeof this.validators["/" + property] === 'undefined') {
            this.validators["/" + property] = [];
        }
        this.validators["/" + property].push(validator);
    };
    SchemaModule.prototype.setupValidators = function () {
        // Automatically apply the custom validator for array properties if needed
        if (this.schema && typeof this.schema.required !== 'boolean') {
            for (var _i = 0, _a = this.schema.required; _i < _a.length; _i++) {
                var property = _a[_i];
                if (this.schema.properties[property].type === 'array') {
                    this.validatorRequiredArray(property);
                }
            }
        }
    };
    return SchemaModule;
}());
export { SchemaModule };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module.ts.pre-build-optimizer.js